<div class="gl-dashboard__header">
  <div class="gl-dashboard__title">
    <span>{{ 'dashboard.widgets.applicabilityWidget' | translate }}</span>
    <button
      type="button"
      lmsTooltip
      [tooltipConfig]="{
        positionV: 'top',
        positionH: 'center',
        text: ['dashboard.widgets.applicabilityWidget' | translate]
      }"
      class="un-btn"
    >
      <span class="glicon-info"></span>
    </button>
  </div>
</div>
<div *ngIf="!isEmpty; else NoApplicabilityData">
  <div class="gl-dashboard__select">
    <lms-select-dropdown
      [items]="courseOptionList"
      [selectedItem]="selectedCourse?.key"
      (change)="setSelectedCourse($event)"
    ></lms-select-dropdown>
  </div>

  <div class="gl-dashboard__survey--answers">
    <div class="label">{{ 'dashboard.widgets.surveyAnswerLabel' | translate }}</div>
    <div class="value">{{ metricApplicabilityData.surveysCount || 0 }}</div>
  </div>
  <div class="gl-dashboard__title x-small">
    <span>{{ 'dashboard.widgets.surveyResultsTitle' | translate }}</span>
    <button
      type="button"
      lmsTooltip
      [tooltipConfig]="{
        positionV: 'top',
        positionH: 'center',
        text: ['dashboard.widgets.surveyResultsTitle' | translate]
      }"
      class="un-btn"
    >
      <span class="glicon-info"></span>
    </button>
  </div>
  <div class="gl-dashboard__survey--results">
    <div>
      <div class="label">{{ 'dashboard.widgets.surveyResultText1' | translate }}</div>
      <div class="value">{{ ((metricApplicabilityData.applicability | number : '1.0-1') || 0) + '%' }}</div>
    </div>
    <div>
      <div class="label">{{ 'dashboard.widgets.surveyResultText2' | translate }}</div>
      <div class="value">{{ ((metricApplicabilityData.improvement | number : '1.0-1') || 0) + '%' }}</div>
    </div>
  </div>
  <div class="gl-dashboard__title x-small">
    <span>{{ 'dashboard.widgets.surveyAspectTitle' | translate }}</span>
  </div>

  <!-- Aspect graphic charts-->
  <div class="gl-dashboard__cards">
    <div class="gl-dashboard__cards--item" *ngIf="metricApplicabilityData.salesIncrease > 0">
      <div class="label">{{ 'dashboard.widgets.surveyAspectTitle1' | translate }}</div>
      <div class="gl-dashboard__circleChart">
        <div class="gl-dashboard__circleChart--item">
          <lms-pie-chart [progressNum]="metricApplicabilityData.salesIncrease"></lms-pie-chart>
          <div class="gl-dashboard__circleChart--icon svg-1"></div>
        </div>
        <div class="gl-dashboard__circleChart--progress">
          {{ (metricApplicabilityData.salesIncrease | number : '1.0-1') + '%' }}
        </div>
      </div>
    </div>

    <div class="gl-dashboard__cards--item" *ngIf="metricApplicabilityData.costSavings > 0">
      <div class="label">{{ 'dashboard.widgets.surveyAspectTitle2' | translate }}</div>
      <div class="gl-dashboard__circleChart">
        <div class="gl-dashboard__circleChart--item">
          <lms-pie-chart [progressNum]="metricApplicabilityData.costSavings"></lms-pie-chart>
          <div class="gl-dashboard__circleChart--icon svg-2"></div>
        </div>
        <div class="gl-dashboard__circleChart--progress">
          {{ (metricApplicabilityData.costSavings | number : '1.0-1') + '%' }}
        </div>
      </div>
    </div>

    <div class="gl-dashboard__cards--item" *ngIf="metricApplicabilityData.productivityIncrease > 0">
      <div class="label">{{ 'dashboard.widgets.surveyAspectTitle3' | translate }}</div>
      <div class="gl-dashboard__circleChart">
        <div class="gl-dashboard__circleChart--item">
          <lms-pie-chart [progressNum]="metricApplicabilityData.productivityIncrease"></lms-pie-chart>
          <div class="gl-dashboard__circleChart--icon svg-3"></div>
        </div>
        <div class="gl-dashboard__circleChart--progress">
          {{ (metricApplicabilityData.productivityIncrease | number : '1.0-1') + '%' }}
        </div>
      </div>
    </div>

    <div class="gl-dashboard__cards--item" *ngIf="metricApplicabilityData.engagementIncrease > 0">
      <div class="label">{{ 'dashboard.widgets.surveyAspectTitle4' | translate }}</div>
      <div class="gl-dashboard__circleChart">
        <div class="gl-dashboard__circleChart--item">
          <lms-pie-chart [progressNum]="metricApplicabilityData.engagementIncrease"></lms-pie-chart>
          <div class="gl-dashboard__circleChart--icon svg-4"></div>
        </div>
        <div class="gl-dashboard__circleChart--progress">
          {{ (metricApplicabilityData.engagementIncrease | number : '1.0-1') + '%' }}
        </div>
      </div>
    </div>

    <div class="gl-dashboard__cards--item" *ngIf="metricApplicabilityData.processesOptimization > 0">
      <div class="label">{{ 'dashboard.widgets.surveyAspectTitle5' | translate }}</div>
      <div class="gl-dashboard__circleChart">
        <div class="gl-dashboard__circleChart--item">
          <lms-pie-chart [progressNum]="metricApplicabilityData.processesOptimization"></lms-pie-chart>
          <div class="gl-dashboard__circleChart--icon svg-5"></div>
        </div>
        <div class="gl-dashboard__circleChart--progress">
          {{ (metricApplicabilityData.processesOptimization | number : '1.0-1') + '%' }}
        </div>
      </div>
    </div>

    <div class="gl-dashboard__cards--item" *ngIf="metricApplicabilityData.others > 0">
      <div class="label">{{ 'dashboard.widgets.surveyAspectTitle6' | translate }}</div>
      <div class="gl-dashboard__circleChart">
        <div class="gl-dashboard__circleChart--item">
          <lms-pie-chart [progressNum]="metricApplicabilityData.others"></lms-pie-chart>
          <div class="gl-dashboard__circleChart--icon svg-6"></div>
        </div>
        <div class="gl-dashboard__circleChart--progress">
          {{ (metricApplicabilityData.others | number : '1.0-1') + '%' }}
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #NoApplicabilityData>
  <span class="gl-dashboard__void">{{ 'dashboard.widgets.notSurvey' | translate }}</span>
</ng-template>

<div *ngIf="!isEmpty && clientId" class="gl-dashboard__links positionFixed">
  <a
    class="gl-dashboard__links--item"
    [queryParams]="{ reportType: 'applicability', clientId: clientId }"
    [routerLink]="['/reports/surveys']"
  >
    <span>{{ 'nouns.viewReports' | translate }}</span>
    <span class="glicon-arrow-right"></span>
  </a>
</div>
